<nav class="navbar navbar-expand-sm bg-dark navbar-dark fixed-top">
    <!-- Title of the portfolio -->
    <a class="nav-link" router="pres" (click)="onClick('pres')" style="color:red;">  Accueil </a>

    <!-- Permits to toggle the navbar into a button when the window is reduced -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

    <!-- Elements of the navbar -->
    <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
            <!-- ml-auto : right, mr-auto : left -->

            <li class="nav-item">
                <a class="nav-link" router="pres" (click)="onClick('pres')">Présentation</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" router="exp" (click)="onClick('exp')">Expériences</a>
            </li>

            <li class="nav-item">
                <a class="nav-link" router="form" (click)="onClick('form')">Formations</a>
            </li>

            <li class="nav-item ">
                <a class="nav-link " router="skill " (click)="onClick( 'skill') ">Compétences</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link " router="proj " (click)="onClick( 'proj') ">Projets</a>
            </li>
            <li class="nav-item ">
                <a class="nav-link " router="cont " (click)="onClick( 'cont') ">Contact</a>
            </li>

        </ul>
    </div>
</nav>